import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e8176d6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8176d6')) {
      api.createRecord('4e8176d6', component.options)
    } else {
      api.reload('4e8176d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e8176d6", function () {
      api.rerender('4e8176d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrandSettings/DropoffLocations/index.vue"
export default component.exports